import { use } from 'react';

import { ToastContext, type ToastApi } from './ToastContext';

/**
 * Shows transient messages.
 *
 * @returns the toast API
 * @throws Error when used outside a ToastProvider, which is a wiring mistake
 *     rather than a runtime condition worth handling
 */
export function useToast(): ToastApi {
  const api = use(ToastContext);
  if (api === null) {
    throw new Error('useToast must be called inside a ToastProvider');
  }
  return api;
}
